window.Vendallion = window.Vendallion || {};
Vendallion.Toggler = {};

const MAX_TOGGLER_INDEX = 10;
const activeClassPattern = /^active-(?:[1-9]|10)$/;

const parseActiveIndex = (value) => {
    const parsed = Number.parseInt(value, 10);
    if (Number.isNaN(parsed) || parsed < 1) {
        return 1;
    }

    return Math.min(parsed, MAX_TOGGLER_INDEX);
};

Vendallion.Toggler.Init = () => {
    const togglerElements = document.querySelectorAll('[data-vd-component="toggler"]');
    if (togglerElements.length == 0) return;

    togglerElements.forEach((togglerEl) => {
        const togglerId = togglerEl.getAttribute("data-toggler-id");
        const toggleButtonsWrapper = togglerEl.querySelector(".toggle-buttons-wrapper");
        const toggleSelectBtns = Array.from(togglerEl.querySelectorAll("[data-toggle-select]"));

        toggleSelectBtns.forEach((btn) => {
            btn.addEventListener("click", () => {
                toggleSelectBtns.forEach((b) => b.classList.remove("active"));
                const selectedIndex = parseActiveIndex(btn.getAttribute("data-index"));
                if (toggleButtonsWrapper) {
                    toggleButtonsWrapper.classList.forEach((className) => {
                        if (activeClassPattern.test(className)) {
                            toggleButtonsWrapper.classList.remove(className);
                        }
                    });
                    toggleButtonsWrapper.classList.add(`active-${selectedIndex}`);
                }
                btn.classList.add("active");

                // Remove 'active' from all toggle content elements with the same toggler id
                const allTargetElements = document.querySelectorAll(`[data-toggle-content][data-toggler-id="${togglerId}"]`);
                allTargetElements.forEach((el) => el.classList.remove("active"));

                // Add 'active' to the selected content element(s) with the same toggler id and matching content value
                const targetValue = btn.getAttribute("data-toggle-select");
                const targetElements = document.querySelectorAll(`[data-toggle-content="${targetValue}"][data-toggler-id="${togglerId}"]`);
                targetElements.forEach((el) => el.classList.add("active"));

                // Dispatch a custom event to signal that the toggler has changed
                const event = new CustomEvent("togglerChange", {
                    detail: {
                        togglerId: togglerId,
                        selectedIndex: selectedIndex,
                        targetValue: targetValue,
                    },
                });
                document.dispatchEvent(event);
            });
        });
    });
};

Vendallion.Toggler.Init();
